import { render, staticRenderFns } from "./vPedidos.vue?vue&type=template&id=0c40bd0e&scoped=true"
import script from "./vPedidos.vue?vue&type=script&lang=js"
export * from "./vPedidos.vue?vue&type=script&lang=js"
import style0 from "./vPedidos.vue?vue&type=style&index=0&id=0c40bd0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c40bd0e",
  null
  
)

export default component.exports